import LBox from "@components/LBox";
import { Access } from "@hooks/trpc/useAccesses";
import Hero from "../details/Hero";
import Title from "../details/Title";
import DateTime from "../event/DateTime";
import Location from "../checkout/event/Location";

type CheckoutInfoProps = {
  /** An event off the engine (old rail): music unlocks in its own sheet. */
  access: Extract<Access, { type: "event" }>;
};

export default function CheckoutInfo({ access }: CheckoutInfoProps) {
  const url = access.coverImageUrl || access.artistImage;

  return (
    <LBox flexDirection="row" gap="s3" alignItems="center">
      <Hero.Hero url={url} size={88} imageSize="medium" />

      <LBox flex={1} gap="s2">
        {/* The API names events once (libs/platform-wire eventDisplayTitle). */}
        <Title.Title title={access.title} variant="Body/B1/Medium" />

        <DateTime.DateTime
          startsAtLocal={access.startsAtLocal}
          endsAtLocal={access.endsAtLocal}
          textProps={{ variant: "Body/B2/Medium" }}
          iconProps={{ size: 12 }}
        />
        <Location
          city={access.city}
          country={access.country}
          venue={access.venue}
          textProps={{ variant: "Body/B2/Medium" }}
          iconProps={{ size: 12 }}
        />
      </LBox>
    </LBox>
  );
}
